// extracted by mini-css-extract-plugin
export default {"continue":"_k-z"};